import { render } from "./DetailProduct.vue?vue&type=template&id=b5e9e42e"
import script from "./DetailProduct.vue?vue&type=script&lang=js"
export * from "./DetailProduct.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__